export const ORGANISATION_NAME = 'Rail Monsters';
export const ORGANISATION_URL = 'https://railmonsters.com';
